<script lang="ts" setup>
import { ref, onMounted, toRefs } from 'vue'
import VueDatePicker from '@vuepic/vue-datepicker'
import '@vuepic/vue-datepicker/dist/main.css'
import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import vi from 'date-fns/locale/vi/index'
import { DAY_NAMES } from '~/constants'
import BaseButton from '~/components/common/base-button.vue'
import { useDevice } from '#imports'
dayjs.extend(customParseFormat)

interface DatepickerProps {
  locale?: string
  themeStyle?: string
  isIconCalendar?: boolean
  isRange: boolean
  format?: string
  defaultDate?: { start: string; end: string } | string
  label?: string
  placeholder?: string
  minDate?: Date | string | null
  disabledDates?: Date | string | null
  autoApply?: boolean
  modelAuto?: boolean
}
const props = withDefaults(defineProps<DatepickerProps>(), {
  themeStyle: '',
  format: 'dd/MM/yyyy',
  defaultDate: undefined,
  label: undefined,
  isIconCalendar: true,
  placeholder: undefined,
  minDate: null,
  disabledDates: null,
  autoApply: false,
  modelAuto: false
})
const { themeStyle, format, autoApply, modelAuto, minDate, isRange } = toRefs(props)

const dateFormat = 'dd/MM/yyyy'
const emits = defineEmits(['onSelectDate'])
const { isMobile } = useDevice()
const date = ref()
const datepickerRef = ref()
const datepickerSetting = {
  themeStyle: themeStyle.value,
  locale: 'vi',
  format: format.value,
  enableTimePicker: false,
  monthNameFormat: 'long',
  range: isRange.value,
  autoApply: autoApply.value,
  noToday: true,
  modelAuto: modelAuto.value,
  minDate: minDate.value
}

const selectDate = (): void => {
  datepickerRef.value.selectDate()
}
onMounted(() => {
  if (typeof props.defaultDate === 'string') {
    date.value = dayjs(props.defaultDate)
  } else if (typeof props.defaultDate === 'object') {
    date.value = [dayjs(props.defaultDate.start, dateFormat), dayjs(props.defaultDate.end, dateFormat)]
  } else {
    date.value = ''
  }
})
</script>
<template>
  <div class="datepicker">
    <VueDatePicker
      ref="datepickerRef"
      v-model="date"
      v-bind="datepickerSetting"
      :placeholder="props.placeholder"
      :maxDate="props.disabledDates"
      :noSwipe="isMobile"
      :formatLocale="vi"
      :dayNames="DAY_NAMES"
      @update:model-value="emits('onSelectDate', toRaw(date))"
    >
      <template #input-icon>
        <div class="calendar">
          <img alt="calendar" src="public/assets/images/components/lobby-games/calendar.png" />
        </div>
      </template>
      <template #action-buttons>
        <BaseButton size="small" class="button main main--primary btn-apply" @click="selectDate">Áp dụng</BaseButton>
      </template>
    </VueDatePicker>
  </div>
</template>
<style lang="scss" scoped>
@import '~scssAsset/components/common/base-datepicker.scss';
</style>
